import React from "react";
import "./FlashText.less";

interface FlashTextProps {
    color: string;
    name: string;
    textColor?: string;
}

const FlashText: React.FC<FlashTextProps> = ({ color, textColor, name }) => (
    <div className="flash-text">
        <div
            className="flash-text__content"
            style={{
                backgroundColor: color,
                // TODO(dark-mode): review, white text on CMS-provided background color; suggested text-inv-default
                color: textColor || "#fff",
            }}
        >
            {name}
        </div>
    </div>
);

export default FlashText;
